import { render, staticRenderFns } from "./BookingSupplierEmailView.vue?vue&type=template&id=4c2d8ad3"
import script from "./BookingSupplierEmailView.vue?vue&type=script&lang=js"
export * from "./BookingSupplierEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports